import InterestPageReducer from './InterestPageReducer';

export default from './InterestPageContainer';

export const InterestPageReducers = {
  InterestPageReducer,
};
